// extracted by mini-css-extract-plugin
export var carrierTab = "_5d-0";
export var carrierTabActive = "_5d-1 _5d-0";
export var carrierTabInactive = "_5d-2 _5d-0";
export var carrierTabLabel = "_5d-3";
export var carrierTabLabelActive = "_5d-4 _5d-3";
export var carrierTabLabelInactive = "_5d-5 _5d-3";
export var carrierTabPercentage = "_5d-6";
export var carrierTabPercentageActive = "_5d-7 _5d-6";
export var carrierTabPercentageInactive = "_5d-8 _5d-6";
export var carrierTabWinnable = "_5d-9";
export var carrierTabWinnableActive = "_5d-a _5d-9";
export var carrierTabWinnableInactive = "_5d-b _5d-9";
export var comparisonContainer = "_5d-d";
export var missingRateButton = "_5d-n";
export var missingRateButtonActive = "_5d-o _5d-n";
export var missingRateButtonInactive = "_5d-p _5d-n";
export var missingRateButtonLabel = "_5d-q";
export var missingRateButtonLabelActive = "_5d-r _5d-q";
export var missingRateButtonLabelInactive = "_5d-s _5d-q";
export var sidebar = "_5d-c";
export var strategyButton = "_5d-e";
export var strategyButtonActive = "_5d-f _5d-e";
export var strategyButtonDescription = "_5d-k";
export var strategyButtonDescriptionActive = "_5d-l _5d-k";
export var strategyButtonDescriptionInactive = "_5d-m _5d-k";
export var strategyButtonInactive = "_5d-g _5d-e";
export var strategyButtonLabel = "_5d-h";
export var strategyButtonLabelActive = "_5d-i _5d-h";
export var strategyButtonLabelInactive = "_5d-j _5d-h";
export var unitToggleButton = "_5d-t";
export var unitToggleButtonActive = "_5d-u _5d-t";
export var unitToggleButtonInactive = "_5d-v _5d-t";
export var unitToggleButtonLabel = "_5d-w";
export var unitToggleButtonLabelActive = "_5d-x _5d-w";
export var unitToggleButtonLabelInactive = "_5d-y _5d-w";